import React from 'react';
import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom';
import { Sparkles, AlertTriangle, RefreshCw, Home } from 'lucide-react';

export const RouteError: React.FC = () => {
  const error = useRouteError() as any;
  const navigate = useNavigate();

  // Check if it's a chunk load error (network issue during lazy load)
  const isChunkError = error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('dynamically imported module');

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50 text-slate-800">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-slate-100">
        <div className="mb-6 flex justify-center">
          <div className={`p-4 rounded-full ${isChunkError ? 'bg-indigo-50 text-indigo-600' : 'bg-red-50 text-red-600'}`}>
            {isChunkError ? <Sparkles size={48} /> : <AlertTriangle size={48} />}
          </div>
        </div>

        <h1 className="text-2xl font-bold mb-2 text-slate-900">
          {isChunkError ? 'Ứng dụng đã được cập nhật' : 'Đã xảy ra lỗi'}
        </h1>

        <p className="text-slate-600 mb-8">
          {isChunkError
            ? 'Phiên bản mới đã sẵn sàng. Vui lòng tải lại trang để tiếp tục sử dụng.'
            : isRouteErrorResponse(error)
              ? `${error.status} - ${error.statusText}`
              : error?.message || 'Lỗi không xác định'}
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={handleRetry}
            className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full font-semibold transition-transform active:scale-95 shadow-md shadow-indigo-500/20"
          >
            <RefreshCw size={18} />
            Thử lại
          </button>

          <button
            onClick={() => navigate('/')}
            className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 rounded-full font-semibold transition-colors"
          >
            <Home size={18} />
            Về trang chủ
          </button>
        </div>
      </div>
    </div>
  );
};

export default RouteError;
